import Cookies from 'js-cookie';

export default class ClarityService {
    static getProjectId() {
        if (window.clarity) return process.env.REACT_APP_CLARITY_ID || '';

        return '';
    }

    static setCustomAttributes(path) {
        const sessionId = sessionStorage.getItem('session_id');
        if (window.clarity) {
            window.clarity('identify', Cookies.get('correlation_id'), sessionId, path);
        }
    }

    static setCorrelationId(response) {
        return Cookies.set('correlation_id', response.headers['correlation-id'], {
            expires: 365
        });
    }
}




// WEBPACK FOOTER //
// ./src/components/helpers/clarity.js